import styled from 'styled-components';

export const StyledRipple = styled.div`
  display: inline-block;
  position: relative;
  width: 2rem;
  height: 2rem;

  div {
    position: absolute;
    border: 0.25rem solid #fff;
    opacity: 1;
    border-radius: 50%;
    animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;

    &:nth-child(2) {
      animation-delay: -0.5s;
    }
  }

  @keyframes lds-ripple {
    0% {
      top: 0.8rem;
      left: 0.8rem;
      width: 0;
      height: 0;
      opacity: 1;
    }

    100% {
      top: 0;
      left: 0;
      width: 1.57rem;
      height: 1.57rem;
      opacity: 0;
    }
  }
`;
